import {
  Box,
  Button,
  CircularProgress,
  Drawer,
  Grid,
  Paper,
  Skeleton,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import {
  homepageActions,
  selectAreas,
  selectDistricts,
  selectLoading,
} from "../../saga/homepageSlice";
import MAreaCard from "../../components/MAreaCard";
import { useEffect, useState } from "react";
import { ICountModel, IDistrictData } from "../../models";
import { homepageApi } from "../../homepageApi";
import { ISearchFilter } from "features/searchStore/models";
import { searchStoreActions } from "features/searchStore/saga/searchStoreSlice";
import { KeyboardArrowLeft } from "@mui/icons-material";

export function MSearchByArea() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const areaList = useAppSelector(selectAreas);
  const districtList = useAppSelector(selectDistricts);
  const isLoading = useAppSelector(selectLoading);

  const [info, setInfo] = useState<ICountModel>({
    review_count: 0,
    store_count: 0,
  });
  const [selectedArea, setSelectedArea] = useState<string | null>();
  const [areaLabel, setAreaLabel] = useState<string | null>();
  const [storeNumOfSelected, setstoreNumOfSelected] = useState<number | null>();
  const [selected, setSelected] = useState(false);

  const handleSelectedArea = (
    value: string,
    label: string,
    storeNum: number
  ) => {
    setSelectedArea(value);
    setAreaLabel(label);
    setstoreNumOfSelected(storeNum);
    setSelected(true);
    dispatch(homepageActions.getDistricts(0));
    dispatch(homepageActions.getKeywords(value));
  };

  const handleSelectedDistrict = (e: IDistrictData) => {
    const filterValue: ISearchFilter = {
      area: {
        value: e.PK,
        label: e.Name,
      },
      sort_code: 0,
      minBudget: 0,
      maxBudget: 0,
      genres: [],
      conditions: [],
      scenes: [],
    };
    dispatch(searchStoreActions.setSearchFilter(filterValue));
    navigate("/stores");
  };

  useEffect(() => {
    homepageApi
      .getCount()
      .then((e) => {
        if (e.status === 200) {
          setInfo(e.data.body.data);
        }
      })
      .catch((error) => console.log(error));
    dispatch(homepageActions.getAreas(6));
  }, [dispatch]);

  return (
    <>
      <Box
        my={2}
        bgcolor="white"
        borderBottom={1}
        borderTop={1}
        borderColor="divider"
        p={1}
      >
        {/* <Box
          display="flex"
          justifyContent="start"
          alignItems="center"
          borderBottom={1}
          py={1}
          borderColor="divider"
        >
          <Box
            display="flex"
            alignItems="end"
            justifyContent="center"
            px={1}
            borderRight={1}
            borderColor="divider"
            width="max-content"
          >
            <Typography fontWeight="bold" variant="h4">
              {info.store_count.toLocaleString()}
            </Typography>
            <span>
              <Typography variant="subtitle2">店舗</Typography>
            </span>
          </Box>

          <Box
            display="flex"
            alignItems="end"
            justifyContent="center"
            px={1}
            borderRight={1}
            borderColor="divider"
            flex={1}
          >
            <Typography fontWeight="bold" variant="h4">
              {info.review_count.toLocaleString()}
            </Typography>
            <span>
              <Typography variant="subtitle2">口コミ</Typography>
            </span>
          </Box>

          <Box
            display="flex"
            flex={1}
            alignItems="end"
            justifyContent="center"
            px={2}
          >
            <Typography fontWeight="bold" variant="h4">
              85
            </Typography>
            <span>
              <Typography variant="subtitle2">写真</Typography>
            </span>
          </Box>
        </Box> */}

        <Grid container rowGap={2} sx={{ my: 2 }}>
          {areaList.map((e) => (
            <Grid
              key={e.label}
              xs={6}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box
                onClick={() => handleSelectedArea(e.value, e.label, e.storeNum)}
              >
                <MAreaCard
                  bgImg={e.image}
                  title={e.label}
                  storeNum={e.storeNum}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Drawer
        open={selected}
        onClose={() => setSelected(false)}
        anchor="right"
        variant="temporary"
        PaperProps={{
          sx: {
            width: "100%",
            maxWidth: "100%",
          },
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="relative"
          py={2}
        >
          <Box
            display="flex"
            position="absolute"
            left="8px"
            alignItems="center"
            onClick={() => setSelected(false)}
          >
            <KeyboardArrowLeft />
            <Typography fontWeight="bold">戻る</Typography>
          </Box>
          <Typography
            textAlign="center"
            marginLeft="auto"
            marginRight="auto"
            fontWeight="bold"
            variant="h6"
          >
            エリアから探す
          </Typography>
        </Box>
        <Box p={1}>
          <Box display="flex" alignItems="center" marginBottom={3}>
            <Typography
              fontWeight="bold"
              fontSize="25px"
              sx={{
                marginRight: 4,
                marginLeft: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {areaLabel}
            </Typography>

            <Typography
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {storeNumOfSelected?.toLocaleString()}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {selectedArea && "件"}
            </Typography>
          </Box>

          {isLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center">
              <CircularProgress />
            </Box>
          ) : (
            <Box display="flex" flexWrap="wrap">
              {districtList &&
                districtList.map((e) => (
                  <Box
                    key={e.PK}
                    border={1}
                    borderColor="divider"
                    borderRadius={2}
                    sx={{
                      padding: 1,
                      m: 1,
                      "&:hover": {
                        cursor: "pointer",
                        color: "primary.main",
                      },
                    }}
                    onClick={() => handleSelectedDistrict(e)}
                  >
                    {e.Name}
                  </Box>
                ))}
            </Box>
          )}
        </Box>
      </Drawer>
    </>
  );
}
